import styled from 'styled-components';

import { rgba } from 'polished';

export const Container = styled.button`
  display: block;
  font-family: 'Sora', sans-serif;
  width: 100%;
  background: none;
  border: 3px solid transparent;
  padding: 10px;
  border-radius: 5px;

  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGrey};
  }

  section {
    div.wrapper {
      display: flex;
      align-items: center;

      div.icon-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        border-radius: 5px;
        background-color: ${({ color }) =>
          color ? rgba(color, 0.1) : 'transparent'};
        margin-right: 10px;
        overflow: hidden;

        svg {
          color: ${({ color }) => color || 'transparent'};
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      div.info {
        display: flex;
        flex-direction: column;
        flex: 1;

        header,
        footer {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;

          > strong {
            font-weight: 700;
            color: ${({ theme }) => theme.colors.softBlack};
            display: flex;
            align-items: flex-end;
            text-align: left;

            &:first-child {
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            &:last-child {
              white-space: nowrap;
              margin-left: 10px;
            }

            svg {
              margin-left: 5px;
            }
          }

          > span {
            font-size: 13px;
            color: ${({ theme }) => theme.colors.grey};
          }
        }

        footer {
          margin-top: 8px;
        }

        div.progress-bar {
          margin-top: 8px;
        }
      }
    }

    > div.progress-bar {
      width: calc(100% - 54px);
      margin: 8px 0 0 54px;
    }
  }
`;
